/**
 * TagChip — display a single tag with optional remove button.
 *
 * A13-N11.
 *
 * Props:
 *  - tag: { id, tag_name, source }
 *  - onRemove: () => void (optional)
 */

export default function TagChip({ tag, onRemove }) {
  const isUserAdded = tag.source === 'user_added';

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs border ${
        isUserAdded
          ? 'bg-[var(--aif-color-info-light)] text-[var(--aif-color-info)] border-[var(--aif-color-info-border)]'
          : 'bg-[var(--aif-bg-surface)] text-[var(--aif-text-secondary)] border-[var(--aif-border-default)]'
      }`}
      data-testid={`tag-${tag.canonical_form || tag.tag_name}`}
    >
      <span>#{tag.tag_name}</span>
      {onRemove && (
        <button
          onClick={onRemove}
          aria-label={`Tag entfernen: ${tag.tag_name}`}
          className="ml-0.5 text-[var(--aif-text-muted)] hover:text-[var(--aif-color-danger)] text-sm leading-none"
        >
          ×
        </button>
      )}
    </span>
  );
}
